import fastdom from "fastdom"

const ICON_EXPAND = "fa-expand"
const ICON_SHRINK = "fa-compress"

/**
 * Changes the use attribute within an svg element
 * @param {String} icon - 'shrink' or 'expand'
 * @param {HTMLButtonElement} el - the primary of secondary buttons
 * @returns {void}
 */
export default function changeButtonIcon(icon, el) {
  const i = el.querySelector("i")
  if (!i) return

  if (icon === "expand")
    fastdom.mutate(() => {
      i.classList.replace(ICON_SHRINK, ICON_EXPAND)
    })
  if (icon === "shrink")
    fastdom.mutate(() => {
      i.classList.replace(ICON_EXPAND, ICON_SHRINK)
    })
}
